import BaseService from './BaseService';
import { getLogger } from 'core/utils';

const log = getLogger("BaseEntityService");

export default class BaseEntityService
    extends BaseService {
  constructor({ baseUrl }) {
    super();

    if (!baseUrl) {
      log.error('Missing parameter: baseUrl');
      throw Error('Missing parameter: baseUrl');
    }

    this.baseUrl = baseUrl;
  }

  async create(queryParams) {
    log.debug("Creating");

    return await this.get({
      url: this.baseUrl + '/new',
      queryParams
    });
  }

  async load({ id }) {
    if (!id) {
      log.error('Missing parameter: id');
      throw Error('Missing parameter: id');
    }

    log.debug("Loading ", id);

    return await this.get({
      url: this.baseUrl + '/' + id
    });
  }

  beforeSave({ instance }) {
    return instance;
  }

  async insert({ instance }) {
    if (!instance) {
      log.error('Missing parameter: instance');
      throw Error('Missing parameter: instance');
    }

    instance = this.beforeSave({ instance });

    log.debug("Inserting ", instance);

    return await this.post({
      url: this.baseUrl,
      data: instance
    });
  }

  async update({ instance }) {
    if (!instance) {
      log.error('Missing parameter: instance');
      throw Error('Missing parameter: instance');
    }

    instance = this.beforeSave({ instance });

    log.debug("Updating ", instance);

    return await this.put({
      url: this.baseUrl + '/' + instance.id,
      data: instance
    });
  }

  async save({ instance, isNew }) {
    if (!instance) {
      log.error('Missing parameter: instance');
      throw Error('Missing parameter: instance');
    }

    if (isNew === undefined || isNew === null) {
      log.error("Missing parameter: isNew");
      throw new Error("Missing parameter: isNew");
    }

    log.debug("Saving ", instance, isNew);

    return isNew
      ? await this.insert({ instance })
      : await this.update({ instance });
  }

  async find({ parameters, pageRequest, sort } = {}) {
    log.debug("Finding ", parameters, pageRequest, sort);

    return await this.get({
      url: this.baseUrl,
      queryParams: [
        parameters,
        pageRequest
          ? { page: pageRequest.number, size: pageRequest.size }
          : { page: 0, size: 0 },
        sort
          ? { sort: sort.sort, order: sort.order && sort.order.toUpperCase() }
          : {}
      ]
    });
  }

  async exportResults({ parameters, sort, exportType } = {}) {
    log.debug("Finding ", parameters, sort, exportType);

    return await this.get({
      url: this.baseUrl,
      queryParams: [
        parameters,
        { page: 0, size: 0 },
        { export: exportType },
        sort
          ? { sort: sort.sort, order: sort.order.toUpperCase() }
          : {}
      ],
      blob: true
    });
  }

  async remove({ id }) {
    if (!id) {
      log.error('Missing parameter: id');
      throw Error('Missing parameter: id');
    }

    log.debug("Deleting ", id);

    if (!id) {
      throw Error('Missing parameter: id');
    }

    return await this.delete({
      url: this.baseUrl + '/' + id
    });
  }
}
